import React from 'react'

function AboutSolution() {
  return (
    <div className='rounded-lg mb-2'>
          <div className="bg-white px-6 rounded-lg sm:px-10 md:px-20 lg:px-32 py-12 mt-3">
      {/* Title Section */}
      <h2 className="text-2xl sm:text-3xl md:text-3xl font-bold text-gray-900 uppercase">
        About Arabian Karim Trading Co. LLC. (AKT):
      </h2>
      <h3 className="text-2xl sm:text-2xl md:text-3xl font-bold text-gray-900 uppercase mt-2">
        Solutions for Your Industrial Needs
      </h3>

      {/* Description */}
      <p className="text-gray-700 mt-4 text-justify md:text-justify sm:text-lg leading-relaxed">
        As a leading trade firm based in the Eastern Region of Saudi Arabia, Arabian Karim
        Trading Co. LLC. (AKT) has been committed to providing high-quality industrial products
        and solutions since 1994. With a strong legacy and global partnerships, we offer the
        expertise and resources needed to drive success across a variety of industries.
        
        Our products and services are the result of years of dedication to delivering reliable
        solutions for industrial tools, equipment, building materials, heavy equipment parts,
        and lubricants.
      </p>

      {/* Impactful Solutions Section */}
      <h3 className="text-2xl sm:text-2xl md:text-3xl md:text-justify font-bold text-gray-900 uppercase mt-8">
        Impactful Solutions Across Industries
      </h3>

      <p className="text-gray-700 mt-4 text-justify sm:text-lg leading-relaxed">
        At AKT, we cater to a wide array of industries with a diverse product portfolio that
        includes industrial tools & supplies, building materials, industrial equipment, heavy
        equipment parts, and lubricants. Our solutions are designed to enhance performance and
        ensure efficiency in sectors such as:
      </p>

      {/* Industry List - Two Column Layout */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
        <ul className="list-disc text-gray-700 pl-5 space-y-1 text-lg">
          <li>Household and Laundry</li>
          <li>Industrial Production</li>
          <li>Oil and Gas</li>
          <li>Packaging and Converting</li>
          <li>Pharmaceuticals</li>
          <li>Renewable Energy</li>
          <li>Tapes and Labels</li>
          <li>Textile Leather and Nonwoven</li>
          <li>Tire and Rubber</li>
          <li>Transportation</li>
          <li>Aerospace</li>
        </ul>
        <ul className="list-disc text-gray-700 pl-5 space-y-1 text-lg">
          <li>Agriculture</li>
          <li>Automotive</li>
          <li>Beauty and Personal Care</li>
          <li>Building and Construction</li>
          <li>Consumer Goods</li>
          <li>Electrical Transmission and Distribution</li>
          <li>Electronics</li>
          <li>Food and Beverage</li>
          <li>Furniture Bedding and Carpets</li>
          <li>Health Care</li>
          <li>Home Appliances</li>
        </ul>
      </div>

      {/* Closing Statement */}
      <p className="text-gray-700 mt-6 text-base sm:text-lg leading-relaxed">
        Our ability to meet the unique needs of each industry is a cornerstone of our continued
        success.
      </p>
    </div>
    </div>
  )
}

export default AboutSolution
